import { z } from 'zod';

const IssueTypeSchema = z.object({
	issueTypeId: z.string(),
	name: z.string(),
	avatarUrl: z.string().optional(),
});

const UserSchema = z.object({
	accountId: z.string().catch(''),
	name: z.string().catch(''),
	avatarUrl: z.string().optional().catch(''),
});

const UserSchemaWithFieldWrapper = z
	.object({
		__typename: z.string().nullable().optional().catch(null),
		status: z.enum(['INIT', 'READY', 'LOADING', 'ERRORED']),
		error: z.string().nullable().optional().catch(null),
		user: UserSchema.nullable().catch(null),
	})
	.optional()
	.nullable();

export const parseUser = (
	value: unknown,
):
	| {
			status: 'INIT' | 'READY' | 'LOADING' | 'ERRORED';
			user: {
				name: string;
				accountId: string;
				avatarUrl?: string | undefined;
			} | null;
			error?: string | null | undefined;
			__typename?: string | null | undefined;
	  }
	| null
	| undefined => {
	return UserSchemaWithFieldWrapper.parse(value);
};

export const parseUsers = (
	value: unknown[],
): (
	| {
			status: 'INIT' | 'READY' | 'LOADING' | 'ERRORED';
			user: {
				name: string;
				accountId: string;
				avatarUrl?: string | undefined;
			} | null;
			error?: string | null | undefined;
			__typename?: string | null | undefined;
	  }
	| null
	| undefined
)[] => {
	return value.map(parseUser);
};

export const parseIssueType = (value: unknown): string => {
	return IssueTypeSchema.parse(value).issueTypeId;
};
